<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-marketing" class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-dark-800 dark:bg-dark-700 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Marketing' : 'Tambah Marketing' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputTextCustom v-model="marketingName" id="marketing-name" label="Nama Marketing"
          placeholder="Masukkan nama marketing" input_class="w-full" :valid="validation.name.valid"
          :error-message="validation.name.message" />
        <InputTextCustom v-model="marketingPhone" id="marketing-phone" label="No. HP" placeholder="Masukkan nomor HP"
          input_class="w-full" :valid="validation.phone.valid" :error-message="validation.phone.message" />
        <InputTextCustom v-model="marketingEmail" id="marketing-email" label="Email" placeholder="Masukkan email"
          input_class="w-full" :valid="validation.email.valid" :error-message="validation.email.message" />
        <InputTextAreaCustom v-model="marketingAddress" id="marketing-address" label="Alamat"
          placeholder="Masukkan alamat" input_class="w-full" :valid="validation.address.valid"
          :error-message="validation.address.message" />
          <!-- <Textarea v-model="value" rows="5" cols="30" /> -->
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitMarketing" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputTextAreaCustom from '../form/InputTextAreaCustom.vue';
import InputTextCustom from '../form/InputTextCustom.vue';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';

export default {
  name: "ModalMarketing",
  props: {
    marketing: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputTextCustom, InputTextAreaCustom
  },
  data() {
    return {
      showModal: true,
      marketingName: this.marketing ? this.marketing.name : '',
      marketingPhone: this.marketing ? this.marketing.phone : '',
      marketingEmail: this.marketing ? this.marketing.email : '',
      marketingAddress: this.marketing ? this.marketing.address : '',
      showErrorDialog: false,
      errorMessage: '',
      validation: {
        name: {
          valid: true,
          message: ''
        },
        phone: {
          valid: true,
          message: ''
        },
        email: {
          valid: true,
          message: ''
        },
        address: {
          valid: true,
          message: ''
        }
      },
      field: ['name', 'phone', 'email', 'address'],
      isEdit: !!this.marketing
    }
  },
  watch: {
    marketing(newVal) {
      if (newVal) {
        this.marketingName = newVal.name;
        this.marketingPhone = newVal.phone;
        this.marketingEmail = newVal.email;
        this.marketingAddress = newVal.address;
        this.isEdit = true;
      } else {
        this.marketingName = '';
        this.marketingPhone = '';
        this.marketingEmail = '';
        this.marketingAddress = '';
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('marketings', ['createMarketing', 'updateMarketing']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitMarketing() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan marketing?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postMarketing();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan marketing', life: 3000 });
        }
      });
    },
    async postMarketing() {
      try {
        const marketingData = {
          name: this.marketingName,
          phone: this.marketingPhone,
          email: this.marketingEmail,
          address: this.marketingAddress
        };

        if (this.isEdit && this.marketing) {
          marketingData.id = this.marketing.id;
          await this.updateMarketing(marketingData);
        }
        else {
          await this.createMarketing(marketingData);
        }
        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Marketing berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save marketing:', error.response.data.errors);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>
